import { UNICO_CONSTANTS } from 'redesign/constants'

export function getOrigin(origin: string | undefined): string {
    if (origin === UNICO_CONSTANTS.ORIGIN.OTP) {
        return UNICO_CONSTANTS.ORIGIN_VALUE.OTP
    }
    if (origin === UNICO_CONSTANTS.ORIGIN.RECOVER) {
        return UNICO_CONSTANTS.ORIGIN_VALUE.RECOVER
    }
    return UNICO_CONSTANTS.ORIGIN_VALUE.DEFAULT
}
